<template>
  <a-spin :spinning="spinning">
    <template #indicator>
      <Loading></Loading>
    </template>
    <div>
      <div class="payments" v-if="orderDetails && !refreshPage">
        <PcCheckout v-if="isPC" ref="pcCheckout" class="pc-checkout" :order="orderDetails"></PcCheckout>
        <MobileCheckout v-else ref="mobileCheckout" class="mobile-checkout" :order="orderDetails"></MobileCheckout>
      </div>
    </div>
  </a-spin>
</template>
<script>
import { getOrderInfo } from '@/views/checkout/api'
import { mapActions } from 'vuex'
import PcCheckout from '@/views/checkout/payment/components/pc.vue'
import MobileCheckout from '@/views/checkout/payment/components/mobile.vue'
import Loading from '@/components/loading'
import { submitOperationData } from '@/views/checkout/tools/collect'

import { loadScript } from '@/views/checkout/tools/utils'

export default {
  components: { PcCheckout, MobileCheckout, Loading },
  data() {
    return {
      orderDetails: null,
      orderId: this.$route.params.id,
      spinning: false,
      refreshPage: false,
      isPC: true,
      countdown: 0
    }
  },
  async created() {
    // 必须先加载 Apple Pay SDK（注册 window.ApplePaySession 和 <apple-pay-button>），
    // 否则订单数据渲染时 checkSupport 检测不到 ApplePaySession 会把 ApplePay 过滤掉
    await this.loadApplePayScript()
    await this.initOrderInfo()
  },
  mounted() {
    // 添加事件监听
    window.addEventListener('beforeunload', this.onBeforeUnload)
    // 添加事件监听器
    window.addEventListener('resize', this.onResize)
    // postTestRecordEvents()
    this.isCurrentPc()
  },
  // beforeDestroy() {
  //   // 添加事件监听
  //   window.removeEventListener('unload', this.onBeforeUnload);
  // },
  methods: {
    ...mapActions('app', ['applyTheme']),
    loadApplePayScript() {
      // SDK 加载失败（网络受限等）不阻塞订单页渲染，只是不展示 ApplePay
      return loadScript('https://applepay.cdn-apple.com/jsapi/1.latest/apple-pay-sdk.js', {
        crossOrigin: 'anonymous'
      }).catch(() => {})
    },
    isCurrentPc() {
      this.isPC = window.innerWidth > 900
    },
    onResize() {
      this.isCurrentPc()
    },
    onBeforeUnload() {
      submitOperationData()
    },
    setAllCountdown() {
      if (this.$refs.pcCheckout) {
        this.$refs.pcCheckout.setCountdown(this.countdown)
      }
      if (this.$refs.mobileCheckout) {
        this.$refs.mobileCheckout.setCountdown(this.countdown)
      }
    },
    async initOrderInfo() {
      try {
        this.spinning = true
        const res = await getOrderInfo(this.orderId)
        if (+res.status === 100) {
          this.$router.push({
            name: 'CheckoutSuccess',
            params: { id: this.orderId }
          })
          return
        } else if (+res.status === 102) {
          this.$router.push({
            name: 'CheckoutPending',
            params: { id: this.orderId }
          })
          return
        } else if (+res.status !== 200) {
          this.$router.push({
            name: 'CheckoutFailed',
            params: { id: this.orderId }
          })
          return
        }
        this.orderDetails = res
        // 根据后端返回的主题标识应用主题
        if (res.themeColor) {
          this.applyTheme(res.themeColor)
        }
        if (this.orderDetails.supportCreditCard && this.orderDetails.paymentLogos) {
          for (let index = 0; index < this.orderDetails.paymentLogos.length; index++) {
            const element = this.orderDetails.paymentLogos[index]
            if (element.code === 'CREDITCARD') {
              this.orderDetails.paymentLogos[index] = {
                cardName: 'Credit/Debit Card',
                code: 'CARD',
                logo: null,
                logoUrl: require('../../../assets/images/checkout/card.png'),
                supportCountry: ['ALL'],
                requiredFields: this.orderDetails.requiredFields
              }
              break
            }
          }
        }
        this.countdown = this.orderDetails.expires
        this.$nextTick(() => {
          this.setAllCountdown()
        })
        const timer = setInterval(() => {
          if (this.countdown > 0) {
            this.countdown -= 1
            this.setAllCountdown()
          } else {
            clearInterval(timer)
          }
        }, 1000)
        this.spinning = false
      } catch (error) {
        console.error(error)
        this.$router.push({
          name: 'CheckoutFailed',
          params: { id: this.orderId }
        })
        this.spinning = false
      }
    },
    onLanguageChange() {
      this.refreshPage = true
      this.$nextTick(() => {
        this.refreshPage = false
        this.$nextTick(() => {
          this.setAllCountdown()
        })
      })
    }
  },
  watch: {
    '$store.getters.app.currentLan': 'onLanguageChange'
  }
}
</script>
<style lang="less" scoped>
@import '~@/styles/common.less';

.payments {
  .mobile-checkout {
    display: none;
  }
}

@media screen and(max-width: 900px) {
  .payments {
    .pc-checkout {
      display: none;
    }

    .mobile-checkout {
      display: block;
    }
  }
}
</style>
